/**
 * UI Preferences State
 * 
 * Manages user interface preferences that should persist across sessions
 */

const initialState = {
  hideCompletedReservations: false,
};

// Action types
const SET_HIDE_COMPLETED_RESERVATIONS = 'uiPreferences/setHideCompletedReservations';

// Action creators
export const setHideCompletedReservations = (hideCompleted) => ({
  type: SET_HIDE_COMPLETED_RESERVATIONS,
  payload: hideCompleted,
});

// Reducer
export default function uiPreferencesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_HIDE_COMPLETED_RESERVATIONS:
      return {
        ...state,
        hideCompletedReservations: action.payload,
      };
    default:
      return state;
  }
}
